import "./style.css";

export default class Dots {
  static selector = ".carousel-dots";

  constructor(block) {
    this.block = block;
  }
}
